import { useEffect, useState } from 'react';

import { MESSAGE_STATE_ERROR, MESSAGE_STATE_SUCCESS } from 'constants/message-app-state-contants';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button, Input, InputGroup, Toggle, ToggleSwitch } from 'components/FormComponents';

import { IntegrationCard } from '../IntegrationCard/IntegrationCard';

export const LivehireIntegration = ({
  config,
  integration,
  setLoading = () => {},
  popUpMessage = () => {},
  connectLivehire = () => {},
  disconnectLivehire = () => {},
}) => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(integration.enabled);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: integration });

  useEffect(() => {
    if (enabled || !integration.enabled) return;

    disconnectLivehire();
    popUpMessage(t('components.integrations.livehire.disabled'), MESSAGE_STATE_SUCCESS);
  }, [enabled]);

  const onSubmit = async data => {
    delete data.enabled;
    setLoading(true);
    const { payload } = await connectLivehire(data);

    if (payload.error)
      popUpMessage(t('components.integrations.livehire.enableError'), MESSAGE_STATE_ERROR);
    else popUpMessage(t('components.integrations.livehire.enabled'), MESSAGE_STATE_SUCCESS);

    setLoading(false);
  };

  return (
    <IntegrationCard {...config} enabled={enabled} onToggle={e => setEnabled(e.target.checked)}>
      {enabled && (
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <InputGroup title={t('components.integrations.livehire.inputs.clientId')}>
            <Input
              name="livehire_client_id"
              register={register}
              placeholder={t('components.integrations.livehire.inputs.clientId')}
              validators={{ required: true }}
              error={errors?.livehire_client_id?.type}
              inputProps={{ tabIndex: 1 }}
            />
          </InputGroup>
          <InputGroup title={t('components.integrations.livehire.inputs.clientSecret')}>
            <Input
              name="livehire_client_secret"
              register={register}
              placeholder={t('components.integrations.livehire.inputs.clientSecret')}
              validators={{ required: true }}
              error={errors?.livehire_client_secret?.type}
              inputProps={{ tabIndex: 2 }}
            />
          </InputGroup>
          <InputGroup title={t('components.integrations.livehire.inputs.integrationEmail')}>
            <Input
              name="livehire_integration_email"
              register={register}
              placeholder={t('components.integrations.livehire.inputs.integrationEmail')}
              validators={{ required: true }}
              error={errors?.livehire_integration_email?.type}
              inputProps={{ tabIndex: 3 }}
            />
          </InputGroup>

          <ToggleSwitch
            register={register}
            className="u-margin-top--large"
            name="livehire_hide_widget"
            tooltip={t('components.integrations.livehire.inputs.hideWidgetTooltip')}
            label={t('components.integrations.livehire.inputs.hideWidget')}
          />

          <Button submit type="secondary" className="w-full mb-3">
            Save
          </Button>
        </form>
      )}
    </IntegrationCard>
  );
};
